// credits to https://usehooks.com/useLocalStorage/

import { dequal as deepEqual } from 'dequal';
import { useCallback, useState } from 'react';

export function useLocalStorage<T = any>(key: string, initialValue: T): [T, (value: T) => void] {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = useCallback(
    (value: T) => {
      try {
        if (!deepEqual(storedValue, value)) {
          // Save state
          setStoredValue(value);
          // Save to local storage
          window.localStorage.setItem(key, JSON.stringify(value));
        }
      } catch (error) {
        // A more advanced implementation would handle the error case
        // TODO: handle error
      }
    },
    [key, storedValue]
  );

  return [storedValue, setValue];
}
